var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"stroke-current",attrs:{"stroke-linecap":"round","stroke-linejoin":"round","clip-rule":"evenodd","height":"100%","width":"100%","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"none","stroke-width":"1.5","d":"M18.289 11.996L5.718 23.003 5.71.997l12.578 11z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }